import { useStore } from '@/store';
import i18n from '@/i18n';

const unitTranslationKeys = {
	inches: 'common.units.inches',
	'metric tons': 'common.units.metricTons',
	'US tons': 'common.units.usTons',
};

// Formats a numeric spec value based on the current unit setting.
// Imperial: use en-US (commas for thousands). Metric: use de-DE (periods for thousands).
export function formatMeasurementValue(value, precision) {
	const store = useStore();
	const locale = store.settings.metricUnits ? 'de-DE' : 'en-US';
	const num = typeof value === 'number' ? value : Number(value);
	if (!isFinite(num)) return '';
	if (typeof precision === 'number') {
		return num.toLocaleString(locale, {
			minimumFractionDigits: precision,
			maximumFractionDigits: precision,
		});
	}
	return num.toLocaleString(locale);
}

export function formatMeasurementUnit(units) {
	return unitTranslationKeys[units] ? i18n.global.t(unitTranslationKeys[units]) : units;
}

export function formatMeasurement(value, units) {
	const amount = Array.isArray(value) ? value.join('–') : value;
	return amount + ' ' + formatMeasurementUnit(units);
}

export function formatTonnage(metricValue, usValue) {
	return useStore().settings.metricUnits
		? formatMeasurement(metricValue, 'metric tons')
		: formatMeasurement(usValue, 'US tons');
}
